export const SCAN_LOCATION_REQUESTED = 'SCAN_LOCATION_REQUESTED';
export const SCAN_LOCATION_SUCCEEDED = 'SCAN_LOCATION_SUCCEEDED';
export const FETCH_ALL_LOCATIONS_REQUESTED = 'FETCH_ALL_LOCATIONS_REQUESTED';
export const SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED = 'SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED';
export const ACCESS_LAST_SCAN_PAGE = 'ACCESS_LAST_SCAN_PAGE';
export const SCAN_RACK_FETCH_LIST_LOCATION_REQUESTED = 'SCAN_RACK_FETCH_LIST_LOCATION_REQUESTED';
export const MAP_LATEST_SCAN_TO_LOCATIONS_LIST = 'MAP_LATEST_SCAN_TO_LOCATIONS_LIST';
export const UPDATE_SCAN_RACK_DESTINATION_FILTER = 'UPDATE_SCAN_RACK_DESTINATION_FILTER';
export const PRE_FILL_SCAN_RACK_COMPONENT_FILTER_FILTER = 'PRE_FILL_SCAN_RACK_COMPONENT_FILTER_FILTER';
export const FETCH_NUMBER_OF_PRODUCT_PER_LOCATION_SUCCESSED = 'FETCH_NUMBER_OF_PRODUCT_PER_LOCATION_SUCCESSED';
